/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropvouchernote2Inputs */

const en_dropvouchernote2 = /** @type {(inputs: Dropvouchernote2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How to redeem`)
};

const de_dropvouchernote2 = /** @type {(inputs: Dropvouchernote2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinweis zum Einlösen`)
};

/**
* | output |
* | --- |
* | "How to redeem" |
*
* @param {Dropvouchernote2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropvouchernote2 = /** @type {((inputs?: Dropvouchernote2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropvouchernote2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropvouchernote2(inputs)
	return de_dropvouchernote2(inputs)
});
export { dropvouchernote2 as "dropVoucherNote" }